<template>
  <form @submit.prevent="!formActive ? adicionandoUser() : editandoUser()" autocomplete="off">
    <div class="row innerPost">
      <div class="col-sm-3 fotoBuscaBig">
        <FccFotoUser :usuario="user" v-if="Object.keys(user).length > 0 && formActive" />
        <img
          :src="userIcon"
          class="user"
          v-if="Object.keys(user).length === 0 || !formActive"
          alt="Foto"
        />
      </div>
      <div class="col-sm-9">
        <div class="row">
          <div class="col-sm-6" v-if="!formActive">
            <fccInput
              extraClasses="inputLabel"
              v-model="user.usuid"
              required
              @input="listandoIntranetId(user.usuid)"
            >
              Login
            </fccInput>
          </div>

          <div class="col-sm-6" v-if="formActive">
            <fccInput extraClasses="inputLabel" disabled v-model="user.usuid" required>
              Login
            </fccInput>
          </div>
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              v-mask="cpf"
              v-model="userComplemento.usucompdocto"
              required
            >
              CPF
            </fccInput>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mt-4">
            <fccInput
              v-if="formActive"
              extraClasses="inputLabel"
              v-model="userComplemento.usucompnome"
              required
            >
              Nome
            </fccInput>

            <fccInput
              v-if="!formActive"
              extraClasses="inputLabel resultadoNome"
              @input="listandoIntranet(userComplemento.usucompnome)"
              v-model="userComplemento.usucompnome"
              required
            >
              Nome
            </fccInput>
          </div>
        </div>
        <div class="resultadoRedes active" v-if="listaIntranet.length >= 1 && !fechaPesquisa">
          <ul v-for="item in listaIntranet" :key="item.usucompcdfuncionario">
            <li @click="selecionaIntranet(item)">
              <span class="fotoBusca">
                <img :src="userIcon" class="user" :alt="userComplemento.usucompnome" />
              </span>

              <span class="nomeBusca">
                <strong>{{ item.usucompnome }}</strong> <br />
                {{ item.usucompsgsetor }} - {{ item.usucompdssetor }} <br />
                Login: {{ item.usuid }}
              </span>
            </li>
          </ul>
        </div>

        <div class="row">
          <div class="col-sm-3 mt-4" v-if="!externo">
            <fccInput extraClasses="inputLabel" v-model="userComplemento.usucompramal" required
              >Ramal</fccInput
            >
          </div>

          <div class="col-sm-9 mt-4">
            <fccInput
              extraClasses="inputLabel"
              type="email"
              v-model="user.usuemailrecuperacaosenha"
              required
              >Email</fccInput
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row innerPage" v-if="!externo">
      <div class="col-sm-3">
        <fccInput extraClasses="inputLabel" v-model="userComplemento.usucompsgsetor" required
          >Setor</fccInput
        >
      </div>
      <div class="col-sm-9">
        <fccInput extraClasses="inputLabel" v-model="userComplemento.usucompdssetor" required
          >Descrição Setor</fccInput
        >
      </div>
    </div>

    <div class="row innerPage datasTemporario">
      <div class="col-sm-3">
        <label>Ativo</label><br />
        <toggle-button v-model="user.usuativo" :sync="true" />
      </div>

      <div class="col-sm-3" v-if="!formActive">
        <label>Permite emular</label><br />
        <toggle-button v-model="user.usupermiteemular" :sync="true" />
      </div>
      <div class="col-sm-3" v-else>
        <label>Permite emular</label><br />
        <toggle-button
          v-model="user.usupermiteemular"
          @change="ativaEmulado(user.usupermiteemular)"
          :sync="true"
        />
      </div>
      <div class="col-sm-2">
        <label>Temporário</label><br />
        <toggle-button v-model="user.usutemporario" :sync="true" />
      </div>

      <div class="col-sm-3" v-if="user.usutemporario">
        <fccDateInput
          id="dtfimrecrutamento"
          type="datetime"
          :min-datetime="capturaDataAtualSGP()"
          v-model="data.acetemdatafinal"
          required
          class="form-control mt-3"
          >Data Fim (*)</fccDateInput
        >
      </div>
    </div>

    <div class="row datasTemporario">
      <div class="col-sm-3">
        <label>Reconhecimento Facial</label><br />
        <toggle-button v-model="user.usureconhecimentofacial" :sync="true" />
      </div>
      <div class="col-sm-3">
        <label>Permite ser emulado</label><br />
        <toggle-button v-model="user.usupermiteseremulado" :sync="true" />
      </div>
      <div class="col-sm-2" v-if="!externo">
        <label>Acesso externo</label><br />
        <toggle-button v-model="user.usuacessoexterno" :sync="true" />
      </div>
      <div class="col-sm-2" v-if="user.usuacessoexterno">
        <label>Duas etapas</label><br />
        <toggle-button v-model="user.usuloginduasetapas" :sync="true" />
      </div>
    </div>
    <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
  </form>
</template>
<script>
import axios from 'axios'
import store from '../../store'
import FccFotoUser from '@/fccComponents/fccUser/fccUser'
export default {
  props: {
    usuarios: Object,
    usuarioComplemento: Object,
    formActive: Boolean,
    usuarioListandoInterno: Array,
    externo: {
      type: Boolean,
      default: false
    }
  },
  components: { FccFotoUser },
  data() {
    return {
      fechaPesquisa: false,
      listaIntranet: [],
      user: {},
      userComplemento: {},
      cpf: '###.###.###-##',
      userIcon: './src/imagens/user-icon.svg',
      data: [],
      listaDatas: [],
      excluiEmular: false
    }
  },
  methods: {
    selecionaIntranet: function (item) {
      var lista = this.usuarioListandoInterno.find((element) => element.usuid === item.usuid)
      if (lista !== undefined) {
        this.callAlert(item.usucompnome, 'Já possui cadastro', 'error', 'error')
        this.formActive = false
        this.fechaPesquisa = false
        this.limpaIntra()
      } else {
        this.fechaPesquisa = true
        this.user = {
          ...this.user,
          usuid: item.usuid,
          ususenha: '',
          usuativo: true,
          usulembrete: '',
          usuemailrecuperacaosenha: item.usucompdsemail,
          usupermitevariassecoes: true
        }
        this.userComplemento = item
        this.userComplemento.usucomprelatipousu = 1
      }
    },
    listandoIntranetId: function (usuid) {
      if (usuid.length === 0) {
        this.limpaIntra()
      }
      if (usuid.length >= 2) {
        axios
          .get(
            store.state.baseUrlSegurancaSGP + 'Cadastro/listarusuidintranet/' + usuid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.listaIntranet = response.data
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.fechaPesquisa = false
      }
    },
    listandoIntranet: function (username) {
      if (username.length === 0) {
        this.limpaIntra()
      }
      if (username.length >= 4) {
        axios
          .get(
            store.state.baseUrlSegurancaSGP + 'Cadastro/listarusuariointranet/' + username,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.listaIntranet = response.data
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.fechaPesquisa = false
      }
    },
    limpaIntra: function () {
      this.user = {}
      this.listaIntranet = []
      this.userComplemento = {}
    },

    adicionandoUser: function () {
      const item = {
        ...this.user,
        usulembrete: '',
        ususenha: 'Nova Senha',
        usupermitevariassecoes: true,
        usuariocomplemento: {
          ...this.userComplemento,
          usuid: this.user.usuid,
          usucompfoto: '',
          usucompdocto: this.removeAcento(this.userComplemento.usucompdocto),
          usucompstatus: this.user.usuativo,
          usucomprelatipousu:
            this.userComplemento.usucomprelatipousu == null
              ? 1
              : this.userComplemento.usucomprelatipousu,
          usucompcdfuncionario:
            this.userComplemento.usucompcdfuncionario == null
              ? 0
              : this.userComplemento.usucompcdfuncionario,
          usucompdsemail: this.user.usuemailrecuperacaosenha
        },
        usuarioparam: {
          usuid: this.user.usuid,
          notificacao: true,
          tema: 'default'
        },
        usuurlboasvindas: document.location.origin + document.location.pathname + '#/primeiroAcesso'
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          store.state.baseUrlSegurancaSGP + 'Cadastro/incluirlogin',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          if (this.user.usutemporario === true) {
            this.adicionandoDatas()
          }
          if (this.user.usupermiteemular) {
            this.insereEmulador(this.user.usuid)
          }
          this.limpaIntra()
          this.$emit('usuariosListandoInterno')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editUser')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    ativaEmulado: function (item) {
      this.excluiEmular = item == this.emularPermite ? false : true
    },
    editandoUser: function (number = null) {
      if (this.excluiEmular && this.emularPermite) {
        this.deleteEmulador(this.user.usuemuid)
      }
      if (this.excluiEmular && !this.emularPermite) {
        this.insereEmulador(this.user.usuid)
      }
      if (this.user.usuativo && !this.user.usuinterno && !this.user.usuacessoexterno) {
        this.callAlert('Favor escolher um tipo de acesso', 'externo ou interno', 'error', 'error')
        return
      }
      const item = {
        ...this.user,
        usupermitevariassecoes: true,
        usuarioparam: {
          usuid: this.user.usuid,
          notificacao: true,
          tema: 'default'
        },
        usuariocomplemento: {
          ...this.userComplemento,
          usucompstatus: this.user.usuativo,
          usuid: this.user.usuid,
          usucompdocto: this.removeAcento(this.userComplemento.usucompdocto),
          usucompdsemail: this.user.usuemailrecuperacaosenha
        }
      }
      delete item.ususenha
      if (number === null) {
        if (this.user.usutemporario === true) {
          if (this.listaDatas.length === 0) {
            this.adicionandoDatas()
          } else {
            this.editandoDatas()
          }
        }
      }
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          store.state.baseUrlSegurancaSGP + 'Cadastro/alterarlogin',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.limpaIntra()
          this.$emit('usuariosListandoInterno')
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editUser')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editandoDatas: function () {
      this.data.acetemdatafinal = this.$moment(
        this.data.acetemdatafinal,
        'YYYY-MM-DD hh:mm:ss'
      ).format('DD/MM/YYYY hh:mm:ss')
      var datas = {
        ...this.data,
        usuid: this.user.usuid
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          store.state.baseUrlSegurancaSGP + 'AcessoTemporario/alteraracessoTemporario',
          datas,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoDatas: function () {
      this.data.acetemdatafinal = this.$moment(
        this.data.acetemdatafinal,
        'YYYY-MM-DD hh:mm:ss'
      ).format('DD/MM/YYYY hh:mm:ss')
      var datas = {
        ...this.data,
        acetemid: 0,
        usuid: this.user.usuid,
        acetemativo: true
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          store.state.baseUrlSegurancaSGP + 'AcessoTemporario/incluiracessoTemporario',
          datas,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listarDatasTemporarioLogin: function (item) {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          store.state.baseUrlSegurancaSGP +
            'AcessoTemporario/listarAcessoTempPorUsuario?usuID=' +
            item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaDatas = response.data
          if (this.listaDatas.length === 0) {
            this.data.acetemdatainicio = this.dataHoraTipoSGP('08:00')
            this.data.acetemdatafinal = this.dataHoraTipoSGP('17:00')
          } else {
            this.data = response.data[0]
          }
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted() {
    this.user = this.usuarios
    if (this.formActive) {
      this.listarDatasTemporarioLogin(this.user.usuid)
    }
    if (this.externo) {
      this.user.usuacessoexterno = true
      this.user.usuloginduasetapas = true
      this.user.usuinterno = false
    } else {
      this.user.usuinterno = true
    }
    this.userComplemento = this.usuarioComplemento
  }
}
</script>
